module.exports = __webpack_public_path__ + "img/IMG-20191228-WA0028.ce50d708.jpg";